<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-select
                                        :items="entityGroupTypes"
                                        :label="'Select '+type+' Type'"
                                        item-text="name"
                                        return-object
                                        :value="groupType"
                                        :error-messages="entityGroupTypeError"
                                        error-count=2
                                        required
                                        @change="groupType = $event"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="showDocumentRules">
                                <v-col cols="12"
                                       md="3"
                                       v-for="document in documentRules"
                                       :key="document.id"
                                       pa-2>
                                    <DocumentFileContainer
                                            :elevation="getElevation(document.id)"
                                            @click="selected === document.id ? selected = '' : selected=document.id"
                                            :setDocumentRule="document"
                                            :ref="document.id"
                                            :setDocumentFile="documentFiles[document.id]"
                                            :alert="shouldShowAlert(document, true)"
                                            @document-changed = "updateDocument($event, document)"

                                            :belong="entity.id"
                                            :document_type="DOCUMENT_FILE_TYPE.DOCUMENT"
                                            :display_name="document.name"
                                            :created_by="getCreatedBy"
                                            :entity_type="documentType"
                                            :requiresApproval="document.approvalRequired"
                                    ></DocumentFileContainer>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!--switch screen alert -->
        <dialog-alert
                :text="alertText"
                :alert-type="alertType"
                :open="openAlert"
                @alert-closed="alertClosed($event)">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {required} from 'vuelidate/lib/validators';
    import {EMPLOYEE_CLIENT_STATUS} from "../../../shared/enums/EntitiesStatus";
    import {Client, Employee} from '../../../shared/dtos/Dtos';
    import {FORM_STATUS} from '../../../shared/enums/FormStatuses';
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "../../../shared/mixins/FormUnsaved";
    const TextLengthLimitations = ()=> import( "@/components/common/TextLengthLimitations");
    import moment from 'moment';
    import {DOCUMENT_RULE_CONFIGURATIONS} from '@/shared/enums/DocumentRule';
    const DocumentFileContainer = ()=> import(  '@/components/common/DocumentFilesContainer');
    import FileHandler from '@/fileHandler/Handler';
    import {DOCUMENT_FILE_TYPE, DOCUMENT_FILE_STATUS, DOCUMENT_FILE_ENTITY_TYPE} from "@/shared/enums/DocumentFile";

    export default {
        name: "documentFilesForm",
        props: ['id','type'],
        mixins:[formUnsavedMixin],
        components:{
            DialogAlert, TextLengthLimitations, DocumentFileContainer
        },
        data(){
            return {
                documentFileStatusConst: DOCUMENT_FILE_STATUS,
                dateFormat: 'YYYY-MM-DD',
                documentRules: {},
                expiration_date: [],
                issue_date: [],
                loading: false,
                showDocumentRules: false,
                documentFilesToDeactivate: {
                    action: 'inactivated',
                    items:[]
                },
                entityGroupTypes: [],
                groupType: {},
                typeOfEntity: {Client: Client, Employee: Employee},
                documentFiles:{},
                selected: '',
                isSaving: false
            };
        },
         validations: {
            groupType:{
                required
            },
        },
        computed:{
            entityGroupTypeError(){
                const errors = [];
                if (!this.$v.groupType.$dirty) {
                    return errors
                }
                !this.$v.groupType.required && errors.push(this.type+' type is required')
                return errors
            },
            moment(){
                return moment();
            },
            DOCUMENT_RULE_CONFIGURATIONS(){
                return DOCUMENT_RULE_CONFIGURATIONS;
            },
            DOCUMENT_FILE_TYPE(){
                return DOCUMENT_FILE_TYPE;
            },
            getCreatedBy(){
                return this.isClient ? this.entity.id : this.entity.cognitoUsername
            },
            isClient(){
               return this.type == 'Client';
            },
            documentType(){
                return DOCUMENT_FILE_ENTITY_TYPE[this.type.toUpperCase()];
            }
         },
        watch: {
            groupType(newValue){
                    this.showDocumentsRelated();
            }
        },
        methods:{
            getElevation(id){
                return this.selected === id ? 24 : 2;
            },
            async initialize() {
                this.getEntityGroupTypes();

                if(this.id !== undefined){
                    await this.$store.dispatch('get'+this.type,{id: this.id});
                }

                this.entity = this.$store.getters['get'+this.type];

                if(!this.entity.hasOwnProperty('id'))
                    this.close();

                if(this.entity.typeID)
                    this.groupType = {id: this.entity.typeID, name: this.entity.typeName};
            },
            issueDateError(document){
                const errors = [];
                if (this.$v.documentFiles.$each[document.id] && !this.$v.documentFiles.$each[document.id].issue_date.$dirty) {
                    return errors;
                }

                this.$v.documentFiles.$each[document.id] && !this.$v.documentFiles.$each[document.id].issue_date.required && errors.push("The issue date is required")
                return errors;
            },
            expirationDateError(document){
                const errors = [];
                if (this.$v.documentFiles.$each[document.id] && !this.$v.documentFiles.$each[document.id].expiration_date.$dirty) {
                    return errors;
                }

                this.$v.documentFiles.$each[document.id] && !this.$v.documentFiles.$each[document.id].expiration_date.required && errors.push("The expiration date is required")
                return errors;
            },
            shouldShowAlert(document){
                let status = false;

                /**
                 * Checking required
                 */
                if(document.required && !this.entity.documentFiles.hasOwnProperty(document.id))
                {
                    status = DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.REQUIRED;
                }

                /**
                 * Checking expiration
                 */
                if(this.entity.documentFiles.hasOwnProperty(document.id) && document.expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE)
                {
                    let issueDate = this.entity.documentFiles[document.id].issue_date;
                    let expiredInterval = document.expiredInterval.split('-');

                    let expirationDate = moment(issueDate,this.dateFormat).add(expiredInterval[0], expiredInterval[1]);

                    if(expirationDate.isBefore(moment()) || moment(this.entity.documentFiles[document.id].expiration_date, this.dateFormat).isBefore(moment()))
                        status = DOCUMENT_FILE_STATUS.EXPIRED.text;
                }

                /**
                 * Checking approval
                 */
                if(this.entity.documentFiles.hasOwnProperty(document.id) && document.approvalRequired &&
                    this.entity.documentFiles[document.id].status == DOCUMENT_FILE_STATUS.PENDING_APPROVAL.status)
                {
                    status = DOCUMENT_FILE_STATUS.PENDING_APPROVAL.text
                }

                return status;
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: this.type.toLowerCase()+'Table'});
            },
            resetValues(){
                this.$v.$reset();
                this.entity = {...this.typeOfEntity[this.type]};
                this.expiration_date = [];
                this.issue_date = [];
                this.entityGroupTypes = [];
                this.resetDocumentLists();
                this.$store.commit('set'+this.type, null);
            },
            resetDocumentLists(){
                this.documentFilesToDeactivate = {
                    action: 'inactivated',
                        items:[]
                };
                this.documentFiles = {};
                this.documentRules = {};
            },
            async getEntityGroupTypes(){
                this.entityGroupTypes = this.$store.getters['get'+this.type+'Types'];
                if(this.entityGroupTypes.length <= 0){
                    //going backend
                    try{
                        await this.$store.dispatch('get'+this.type+'Types');
                        this.entityGroupTypes = this.$store.getters['get'+this.type+'Types'];
                    }
                    catch (e) {
                        //set alert
                        alertEventBus.setAlert({type:'error', msg: e.message});
                        return;
                    }
                }
            },
            async save() {
                //call each component validate method
                let validation = Object.values(this.documentRules);
                let hasErrors = false;
                for(let doc of validation) {
                   let child = this.$refs[doc.id][0];
                    hasErrors = await child.validate() || hasErrors;
                }

                this.$v.$touch();
                if(this.$v.$anyError || hasErrors)
                    return;

                this.isSaving = true;

                try {
                    /**
                     * Saving the entity group type
                     */
                    this.entity.typeID =  this.groupType.id;
                    this.entity.typeName= this.groupType.name;
                    if(this.groupType.documentGroups)
                        this.entity.documentGroups = this.groupType.documentGroups;

                    /**
                     * Uploading document files and updating the entity documentFiles property
                     * Also we check if the entity needs update verifying that all documents required
                     * are uploaded or if there is no documents expired
                     */
                    this.entity.status = EMPLOYEE_CLIENT_STATUS.READY.status;
                    let documentErrors = [];
                    for(let document in this.documentFiles) {
                        if(this.documentFiles[document].hasOwnProperty('file_id')) {
                            try {
                                //uploading document
                                if(this.documentFiles[document].hasOwnProperty('file')) {
                                    let metadata = {...this.documentFiles[document].metadata};
                                    metadata.issue_date = this.documentFiles[document].issue_date;
                                    if(this.documentFiles[document].expiration_date !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.NO_EXPIRE_TEXT)
                                        metadata.expiration_date = this.documentFiles[document].expiration_date;
                                    metadata.status = this.documentFiles[document].status;
                                    metadata.type = DOCUMENT_FILE_TYPE.DOCUMENT;

                                    await FileHandler.createFile('Document', this.documentFiles[document].file, metadata);
                                }

                                //Adding or editing document file to the array of documents files of the entity
                                this.entity.documentFiles[document] = {
                                    documentRule: this.documentFiles[document].documentRule,
                                    issue_date: this.documentFiles[document].issue_date,
                                    file_id: this.documentFiles[document].file_id,
                                    name: this.documentFiles[document].name,
                                    status: this.documentFiles[document].status
                                };

                                if(this.documentRules[document].expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE)
                                    this.entity.documentFiles[document].expiration_date = this.documentFiles[document].expiration_date;

                                if(this.documentRules[document].approvalRequired)
                                    this.entity.documentFiles[document].reviewer_cognito_username = this.documentFiles[document].reviewer_cognito_username;
                            }
                            catch (e) {
                                documentErrors.push(this.documentFiles[document].name);
                            }
                        }
                        else {
                            //removing from entity document files and inactivating the document file
                            if(this.entity.documentFiles.hasOwnProperty(document) && this.entity.documentFiles[document].file_id)
                            {
                                this.documentFilesToDeactivate.items.push({
                                     id: this.entity.documentFiles[document].file_id,
                                     notifyAdmin: false,
                                     documentRule: document
                                 });

                                delete this.entity.documentFiles[document];
                            }
                        }

                        //checking if entity requires update
                        if(this.entity.status !== EMPLOYEE_CLIENT_STATUS.UPDATE_REQUIRED.status && this.shouldShowAlert(this.documentRules[document]))
                            this.entity.status = EMPLOYEE_CLIENT_STATUS.UPDATE_REQUIRED.status;
                    }

                    /**
                     * Deactivation of documents in filesToDeactivate
                     */
                    if(this.documentFilesToDeactivate.items.length) {
                        //removing documents from entity object
                        for(let file in this.documentFilesToDeactivate.items){
                            delete this.entity.documentFiles[this.documentFilesToDeactivate.items[file].documentRule];
                        }

                        this.$store.dispatch('inactivateDocumentFiles', this.documentFilesToDeactivate);
                    }

                    await this.$store.dispatch('set'+this.type, this.entity);
                    let response = this.$store.getters['get'+this.type];

                    /**
                     * Updating list of Entities
                     */
                    this.$store.commit('set'+this.type+'s', []);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            },
            async showDocumentsRelated() {
                //Reset values of documents lists
                this.showDocumentRules = false;
                this.resetDocumentLists();
                await this.$store.dispatch('get'+this.type+'Type', {id: this.groupType.id});
                let entityGroupType = this.$store.getters['get'+this.type+'Type'];

                if(!entityGroupType || !entityGroupType.documentGroups){
                    alertEventBus.setAlert({type:'error', msg: "There was an error retrieving the documents required"});
                    return;
                }

                for (let i in entityGroupType.documentGroups) {
                    await this.$store.dispatch('getDocumentGroup', {id: entityGroupType.documentGroups[i].id});
                    let template = this.$store.getters.getDocumentGroup;

                    if (template) {
                        for (let d in template.documentRules) {
                            if (template.documentRules.hasOwnProperty(d)) {
                                let temp = {...template.documentRules[d]};
                                temp.expiration_date = DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.NO_EXPIRE_TEXT;//Default value if documet does not expires

                                if(temp.expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE)//If document expires
                                {
                                    if(this.entity.documentFiles.hasOwnProperty(temp.id))//if entity has document already
                                    {
                                        temp.expiration_date =this.entity.documentFiles[temp.id].expiration_date;
                                    }
                                    else{
                                        temp.expiration_date = '';//empty because the document needs a value
                                    }
                                }

                                this.documentRules[temp.id] = temp;

                                //Creating the array of documentFiles that we are going to use tu update the entity
                                if(this.entity.documentFiles.hasOwnProperty(temp.id)) {
                                    this.documentFiles[temp.id] = {
                                        file_id: this.entity.documentFiles[temp.id].file_id,
                                        issue_date: this.entity.documentFiles[temp.id].issue_date,
                                        expiration_date: temp.expiration_date,
                                        documentRule: this.entity.documentFiles[temp.id].documentRule,
                                        name: this.entity.documentFiles[temp.id].name,
                                        status: this.entity.documentFiles[temp.id].status,
                                        //reviewer_cognito_username: this.entity.documentFiles[temp.id].reviewer_cognito_username
                                        reviewer_cognito_username: this.$store.getters.getUser.username
                                    }
                                }
                                else {
                                    this.documentFiles[temp.id] = temp;
                                }
                            }
                        }
                    }
                }
                /**
                 * Getting all documentFiles in entity that are no longer required
                 * if user hits save we are going to set the status for these files to INACTIVE
                 */
                let entityDocumentFilesIds = Object.keys(this.entity.documentFiles);
                let newDocumentRulesIds = Object.keys(this.documentRules);
                let notRequiredDocuments = entityDocumentFilesIds.filter(x => !newDocumentRulesIds.includes(x));

                for(let i = 0; i < notRequiredDocuments.length; i++){
                    this.documentFilesToDeactivate.items.push({
                        id: this.entity.documentFiles[notRequiredDocuments[i]].file_id,
                        notifyAdmin: false,
                        documentRule: notRequiredDocuments[i]
                    });
                }
                this.showDocumentRules = true;
            },
            updateDocument(newDocumentFile, document){
                this.documentFiles[document.id] = {...newDocumentFile};
            }
        },
        async created(){
            this.initialize();
        },
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }

    .v-icon.icon-required{
        font-size:15px;
        margin-left: 5px;
    }

    .document-card{
        min-height: 292px;
    }
</style>